<div>
    <span class="config-name">
        Daily reboot
        <i *ngIf="_lockInfo" class="fas fa-lock ml-2 red-1" data-toggle="tooltip"
            [title]="'Lock by policy <<' + _lockInfo.policyName + '>>'"></i>
    </span>
    <div *ngIf="_unsupportReason" class="warning-block mb-1">{{ _unsupportReason }}</div>
    <div class='switch-container'>
        <input id="cmn-toggle-dailyreboot" class="cmn-toggle cmn-toggle-flat cmn-toggle-rect-flat" type="checkbox"
            [checked]="_info.enabled" [disabled]="_lockInfo || _disabled || _unsupportReason"
            (change)="enableFeature($event.target.checked)">
        <label for="cmn-toggle-dailyreboot">
            <span class="sr-only">Enable daily reboot</span>
        </label>
    </div>
    <ul class="mt-2">
        <li *ngIf="_supportStagger">
            <div class="d-flex align-items-center">
                <div>
                    <span>Stagger reboots over</span>
                    <input id="dailyReboot-stagger-time" type="number" class="mx-2" [attr.min]="STAGGER_TIME_MIN"
                        [attr.max]="STAGGER_TIME_MAX" [value]="_info.staggerRebootWithinMinutes"
                        [disabled]="!_info.enabled || _lockInfo || _disabled || _unsupportReason"
                        (change)="changeStaggerDuration($event.target.value)">
                    <span>min</span>
                </div>
            </div>
        </li>
        <li>
            <div class="weekday-option">
                <label class="mr-2">Reboot on</label>
                <span *ngFor="let weekday of WEEKDAY_ABBR_LIST">
                    <input type="checkbox" [id]="'dailyReboot-day' + weekday" class="cmn-checkbox"
                        [checked]="_info.isWeekdayChecked(weekday)"
                        [disabled]="!_info.enabled || _lockInfo || _disabled || _unsupportReason"
                        (change)="checkWeekday(weekday, $event.target.checked)">
                    <label [for]="'dailyReboot-day' + weekday">
                        <svg>
                            <use xlink:href="#checkmark" />
                        </svg>
                        <span class="sr-only">Select day {{ weekday }}</span>
                    </label>
                    <span class="ml-2">{{ weekday }}</span>
                </span>
            </div>
            <div class="mt-1">
                <na-timePicker [time]="_info.time" [on]="_info.enabled" [autoNotify]="true" [lock]="_lockInfo"
                    [showBorder]="_showBorder" (onTimeChanged)="onDailyRebootTimeChanged($event)">
                </na-timePicker>
            </div>
        </li>
    </ul>



</div>